let debugFuncs = {}

/**
 * デバッグ関連ユーティリティ
 */
if (process.env.NODE_ENV !== 'production') {
  debugFuncs = {
    /**
     * デバッグログ
     *
     * @param console.info() に渡す引数
     */
    log () {
      // eslint-disable-next-line no-console
      console.info.apply(this, arguments)
    },
    /**
     * デバッグログ（エラー）
     *
     * @param console.error() に渡す引数
     */
    error () {
      // eslint-disable-next-line no-console
      console.error.apply(this, arguments)
    }
  }
} else {
  debugFuncs = {
    log () {},
    error () {}
  }
}

export default debugFuncs
